import { render, staticRenderFns } from "./dui-upload-trigger.vue?vue&type=template&id=5953ec6b&scoped=true&"
import script from "./dui-upload-trigger.vue?vue&type=script&lang=js&"
export * from "./dui-upload-trigger.vue?vue&type=script&lang=js&"
import style0 from "./dui-upload-trigger.vue?vue&type=style&index=0&id=5953ec6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5953ec6b",
  null
  
)

export default component.exports